import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import {
	updatePaymentOption,
	TAKEPAYMENTS_CARD_UPDATE_REQUEST, TAKEPAYMENTS_CARD_UPDATE_FAILURE
} from './actions';

class PaymentOptionComponent extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { payment, updatePaymentOption, t } = this.props;

		if (!payment || !payment.paymentOption) {
			return null;
		}

		return <ReduxBlockUi block={TAKEPAYMENTS_CARD_UPDATE_REQUEST} unblock={TAKEPAYMENTS_CARD_UPDATE_FAILURE}>{payment.paymentOption.toUpperCase()}<a style={{ cursor: 'pointer', marginLeft: 20 }} onClick={() => updatePaymentOption(payment)}>{t('FO_Payment_PaymentOption_Update')}</a></ReduxBlockUi>;
	}
}

const mapStateToProps = (state, ownProps) => ({});

export default connect(mapStateToProps, {
	updatePaymentOption
})(withTranslation()(PaymentOptionComponent));